import 'babel-polyfill';

// styles
import '../less/import.less';
import 'react-dates/lib/css/_datepicker.css';

// startup scripts
import 'startup/spBootstrap';
import 'startup/logging';

import React from 'react';
import { render } from 'react-dom';
import runtime from 'serviceworker-webpack-plugin/lib/runtime';

import { getFlag } from 'config/flags';

import Root from './containers/Root';
import createStore from './store/createStore';
import createHistory from './store/createHistory';

export default function startupApp() {
  const isProd = getFlag('env') === 'prod';
  const swEnabled = getFlag('swEnabled') === true;

  if (swEnabled) {
    if ('serviceWorker' in navigator) {
      runtime.register();
    }
  }

  const store = createStore();
  const history = createHistory(store);
  const root = document.getElementById('root');

  if (isProd) {
    return render(<Root store={store} history={history} />, root);
  }

  // dev rendering
  const { AppContainer } = require('react-hot-loader');

  render(
    <AppContainer>
      <Root store={store} history={history} />
    </AppContainer>,
    root
  );

  if (module.hot) {
    module.hot.accept('./containers/Root', () => {
      const NextRoot = require('./containers/Root');
      render(
        <AppContainer>
          <NextRoot store={store} history={history} />
        </AppContainer>,
        root
      );
    });
  }
}

// kick off startup
startupApp();



// WEBPACK FOOTER //
// ./src/app.js